import { render, staticRenderFns } from "./distinguish_restart_stage.vue?vue&type=template&id=1acd82d5&scoped=true"
var script = {}
import style0 from "./distinguish_restart_stage.vue?vue&type=style&index=0&id=1acd82d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd82d5",
  null
  
)

export default component.exports